import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthGate } from '../features/auth/auth-gate'
import { LoginPage } from '../pages/login'
import { ProjectsPage } from '../pages/projects'
import { ProjectBoardPage } from '../pages/project-board'
import { ProjectDetailsPage } from '../pages/project-details'
import { BirthdaysPage } from '../pages/birthdays'
import { ReportsDashboardPage } from '../pages/reports-dashboard'
import { EmployeeReportPage } from '../pages/employee-report'
import { SettingsPage } from '../pages/settings'
import { AdminUsersPage } from '../pages/admin-users'
import { AdminDepartmentsPage } from '../pages/admin-departments'
import { AdminTgBindingsPage } from '../pages/admin-tg-bindings'
import { AdminSegmentsPage } from '../pages/admin-segments'
import { AdminRbacPage } from '../pages/admin-rbac'
import { AdminTgNotificationsPage } from '../pages/admin-tg-notifications'
import { MeTelegramPage } from '../pages/me-telegram'
import { MePasswordPage } from '../pages/me-password'
import { MyWorkPage } from '../pages/my-work'
import { UserActivityLogPage } from '../pages/user-activity-log'

export function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/dashboard"
        element={
          <AuthGate>
            <ReportsDashboardPage />
          </AuthGate>
        }
      />
      <Route
        path="/reports/employee/:id"
        element={
          <AuthGate>
            <EmployeeReportPage />
          </AuthGate>
        }
      />
      <Route
        path="/my"
        element={
          <AuthGate>
            <MyWorkPage />
          </AuthGate>
        }
      />
      <Route
        path="/projects"
        element={
          <AuthGate>
            <ProjectsPage />
          </AuthGate>
        }
      />
      <Route
        path="/projects/:id"
        element={
          <AuthGate>
            <ProjectBoardPage />
          </AuthGate>
        }
      />
      {/* Epic B: CRM details (lifecycle/contacts/birthdays/обзор) */}
      <Route
        path="/projects/:id/details"
        element={
          <AuthGate>
            <ProjectDetailsPage />
          </AuthGate>
        }
      />
      <Route
        path="/birthdays"
        element={
          <AuthGate>
            <BirthdaysPage />
          </AuthGate>
        }
      />
      <Route
        path="/settings"
        element={
          <AuthGate>
            <SettingsPage />
          </AuthGate>
        }
      />
      <Route
        path="/admin/users"
        element={
          <AuthGate>
            <AdminUsersPage />
          </AuthGate>
        }
      />
      <Route
        path="/admin/departments"
        element={
          <AuthGate>
            <AdminDepartmentsPage />
          </AuthGate>
        }
      />
      <Route
        path="/admin/segments"
        element={
          <AuthGate>
            <AdminSegmentsPage />
          </AuthGate>
        }
      />
      <Route
        path="/admin/rbac"
        element={
          <AuthGate>
            <AdminRbacPage />
          </AuthGate>
        }
      />
      {/* Эпик «TG welcome» W7: две секции (bound + orphan); /new — deep-link с предзаполнением. */}
      <Route
        path="/admin/tg-bindings"
        element={
          <AuthGate>
            <AdminTgBindingsPage />
          </AuthGate>
        }
      />
      <Route
        path="/admin/tg-bindings/:mode"
        element={
          <AuthGate>
            <AdminTgBindingsPage />
          </AuthGate>
        }
      />
      {/* #5 (2E): анти-спам — окно тишины + время дайджеста + рассылка, право tg_notifications.manage. */}
      <Route
        path="/admin/tg-notifications"
        element={
          <AuthGate>
            <AdminTgNotificationsPage />
          </AuthGate>
        }
      />
      {/* Эпик «UI tg-link сотрудника» (T12) P3: двух-шаговая привязка TG для всех ролей. */}
      <Route
        path="/me/telegram"
        element={
          <AuthGate>
            <MeTelegramPage />
          </AuthGate>
        }
      />
      {/* Смена своего пароля; принудительная после админского сброса (AuthGate). */}
      <Route
        path="/me/password"
        element={
          <AuthGate>
            <MePasswordPage />
          </AuthGate>
        }
      />
      {/* #7 слой 3 — журнал действий сотрудника. Гейт в самой странице: self ∨ audit.view (Р-C). */}
      <Route
        path="/people/:id/log"
        element={
          <AuthGate>
            <UserActivityLogPage />
          </AuthGate>
        }
      />
      <Route path="/" element={<Navigate to="/projects" replace />} />
      <Route path="*" element={<Navigate to="/projects" replace />} />
    </Routes>
  )
}
